<div
  *ngIf="document"
  class="ui-kit-item-container document"
  (click)="openDocument(document)"
  data-qa="document"
>
  <div class="document-date">
    <span data-qa="document-date-1">{{ document.date | date: 'd MMM' }}</span>
    <span data-qa="document-date-2" class="ui-kit-grey-text"
      >{{ document.date | date: 'yyyy' }} г</span
    >
  </div>
  <div class="document-name" data-qa="document-name" [innerHTML]="document.name"></div>
  <div class="document-kkm-name">
    <div *ngIf="document.kkms.length > 0 && document.kkms[0].name !== ''" data-qa="kkm-name">
      {{ document.kkms[0].name }}
    </div>
  </div>
  <div class="document-kkm-id">
    <div *ngIf="document.kkms.length > 0" data-qa="kkm-id">id:&nbsp;{{ document.kkms[0].id }}</div>
  </div>
</div>
